import React, {PureComponent, cloneElement} from 'react'
import cn from 'classnames'
import axios from 'axios'
import Spinner from 'components/common/elements/Spinner'
import { showError } from 'services/utils'
import Button from 'components/common/buttons/Button'

class File extends PureComponent {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      type: 1,
      file: undefined,
    };
  }

  handleFileChange(event) {
    this.setState({file: event.target.files[0]});
  }
  upload() {
    const { type, file } = this.state;

    this.setState({isLoading: true});

    let formData = new FormData();
    formData.append("type", type);
    formData.append("file", file);

    axios.post('/imports', formData).then(
      response => {
        this.props.handleFileLoad(response);
      }, error => {
        this.setState({isLoading: false});
        showError(error);
      }
    )
  }

  render() {
    const { type, file, isLoading } = this.state;
    const { sequenceId } = this.props;

    return (
      <div className="import-csv-modal-file">
        <div className="import-csv-modal-file-container">
          <label htmlFor="upload_file_csv" className="gs-btn _upload_csv">
            <span className="gs-text _overflow-90 _exlg">
              { file && file.name || "Select .csv file"}
            </span>
            <input id="upload_file_csv"
                   accept=".csv"
                   onChange={ e => this.handleFileChange(e)}
                   type="file"/>
          </label>
        </div>

        {/* !sequenceId && <label> What are you going to import?</label> */}
        {/* !sequenceId && (
          <select value={type}
                  onChange={ e => this.setState({type: e.target.value}) }
                  className="gs-select _md">
            <option value={1}>Prospect</option>
            <option value={2}>Company</option>
          </select>
        ) */}

        <div className="gs-modal__actions gs-modal__footer">
          <Button onClick={ () => this.upload() }
                  disabled={!file}>
            Upload
            { isLoading && <Spinner size={16} /> }
          </Button>
        </div>

      </div>
    )
  }
}

File.propTypes = {
};

export default File;
